import React, { useState } from 'react';

import { Box, Button, H1, PancakeStack, Separator, Sheet, Text } from '@betterment/samba-react';
import { noop } from 'es-toolkit/compat';

import { HouseholdRow } from './HouseholdRow';

import { pluralize } from '../../../../../../utils/strings/strings';
import { SearchInput } from '../../../../../SummarySearch/SearchInput';

interface BillingPlanPageDrawerProps {
  planName: string;
  numberOfClients: number;
  planId: string;
}

export const BillingPlanPageDrawer: React.FC<BillingPlanPageDrawerProps> = ({ planName, numberOfClients, planId }) => {
  const [shouldShowAssignedClients, setShouldShowAssignedClients] = useState(false);
  const [searchText, setSearchText] = useState<string>('');

  const updateQuery = (val: string) => {
    setSearchText(val);
  };

  return (
    <PancakeStack css={{ height: '100vh', display: 'flex', flexDirection: 'column', overflowY: 'scroll' }}>
      <PancakeStack.Header css={{ p: 'space.300', pt: 'space.500', pb: 'space.0' }}>
        <Sheet.Title asChild={true}>
          <H1 css={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} variant="title300">
            {planName}
          </H1>
        </Sheet.Title>
        <Box css={{ my: 'space.300' }}>
          {numberOfClients > 7 && (
            <SearchInput
              isAdmin={false}
              setSearch={updateQuery}
              search={searchText}
              handleFocus={noop}
              placeholder="Search client or household "
            />
          )}
        </Box>
      </PancakeStack.Header>
      <PancakeStack.Main css={{ flex: 1, overflowY: 'auto' }}>
        {shouldShowAssignedClients && (
          <Box
            css={{
              ml: 'space.300',
              mx: 'space.300',
              pb: 'space.100',
              borderBottom: 'token(borderWidths.thin) solid token(colors.border.weak)',
            }}
          >
            <Sheet.Description>
              <Text variant="text50" color="text.weak">
                Assigned to {pluralize(numberOfClients, 'client')}
              </Text>
            </Sheet.Description>
          </Box>
        )}
        <HouseholdRow
          planId={planId}
          searchText={searchText}
          numberOfClients={numberOfClients}
          setShouldShowAssignedClients={setShouldShowAssignedClients}
        />
      </PancakeStack.Main>
      <PancakeStack.Footer css={{ p: 'space.300' }}>
        <Separator css={{ mb: 'space.300' }} />
        <Sheet.Close asChild={true}>
          <Button variant="solidSecondary">Close</Button>
        </Sheet.Close>
      </PancakeStack.Footer>
    </PancakeStack>
  );
};
